export default __webpack_public_path__ + "src/images/packages/villa-mangata/f511ca443d8eab98872ab7410841eba1-1.jpg";